"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validators = _interopRequireDefault(require("../validators"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FormConfigParser = /*#__PURE__*/function () {
  function FormConfigParser() {
    _classCallCheck(this, FormConfigParser);
  }

  _createClass(FormConfigParser, null, [{
    key: "mapValidationRule",
    value: function mapValidationRule(rule) {
      switch (rule.type) {
        //This is used once in Care, needs revision, renamed so it wasn't reused
        case 'careDateIsNotGreater':
          if (rule.data) {
            return _validators.default.careDateIsNotGreater(rule.data.message, rule.data.sectionID, rule.data.fieldID, rule.data.options);
          } else {
            return _validators.default.careDateIsNotGreater();
          }

        case 'isAbn':
          return _validators.default.isAbn(rule.data && rule.data.message);

        case 'isAccepted':
          return _validators.default.isAccepted(rule.data && rule.data.message);

        case 'isAcn':
          return _validators.default.isAcn(rule.data && rule.data.message);

        case 'isAlphaNumeric':
          if (rule.data) {
            return _validators.default.isAlphaNumeric(rule.data.message);
          } else {
            return _validators.default.isAlphaNumeric();
          }

        case 'isDateAfter':
          if (rule.data) {
            return _validators.default.isDateAfter(rule.data.message, rule.data.fieldID);
          } else {
            return _validators.default.isDateAfter();
          }

        case 'isDateBefore':
          if (rule.data) {
            return _validators.default.isDateBefore(rule.data.message, rule.data.fieldID);
          } else {
            return _validators.default.isDateBefore();
          }

        case 'isDateEqualToOrAfter':
          if (rule.data) {
            return _validators.default.isDateEqualToOrAfter(rule.data.message, rule.data.fieldID, rule.data.afterDate);
          } else {
            return _validators.default.isDateEqualToOrAfter();
          }

        case 'isDateEqualToOrBefore':
          if (rule.data) {
            return _validators.default.isDateEqualToOrBefore(rule.data.message, rule.data.fieldID);
          } else {
            return _validators.default.isDateEqualToOrBefore();
          }

        case 'isDateInPast':
          return _validators.default.isDateInPast(rule.data && rule.data.message);

        case 'isDateNotEqualToOrBefore':
          if (rule.data) {
            return _validators.default.isDateNotEqualToOrBefore(rule.data.message, rule.data.fieldID);
          } else {
            return _validators.default.isDateNotEqualToOrBefore();
          }

        case 'isDateTimeEqualToOrBefore':
          if (rule.data) {
            return _validators.default.isDateTimeEqualToOrBefore(rule.data.message, rule.data.fieldID);
          } else {
            return _validators.default.isDateTimeEqualToOrBefore();
          }

        case 'isDateWithinNumDays':
          return _validators.default.isDateWithinNumDays(rule.data);

        case 'isDateWithinNumMonths':
          return _validators.default.isDateWithinNumMonths(rule.data);

        case 'isDateWithinNumYears':
          return _validators.default.isDateWithinNumYears(rule.data);

        case 'isDecimal':
          if (rule.data) {
            return _validators.default.isDecimal(rule.data.message, rule.data.options);
          } else {
            return _validators.default.isDecimal();
          }

        case 'isEmail':
          if (rule.data) {
            return _validators.default.isEmail(rule.data.message);
          } else {
            return _validators.default.isEmail();
          }

        case 'isEmpty':
          if (rule.data && rule.data.message) {
            return _validators.default.isEmpty(rule.data.message);
          } else {
            return _validators.default.isEmpty();
          }

        case 'isInRange':
          if (rule.data) {
            return _validators.default.isInRange(rule.data.message, rule.data.options);
          } else {
            return _validators.default.isInRange();
          }

        case 'isInt':
          if (rule.data) {
            if (!!rule.data.message) {
              return _validators.default.isInt(rule.data.message);
            } else {
              return _validators.default.isInt();
            }
          } else {
            return _validators.default.isInt();
          }

        case 'isLength':
          if (rule.data) {
            return _validators.default.isLength(rule.data.message, rule.data.options);
          } else {
            return _validators.default.isLength();
          }

        case 'isLessThan':
          return _validators.default.isLessThan(rule.data.message, rule.data.options, rule.data.fieldID);

        case 'isLocalPhone':
          return _validators.default.isLocalPhone(rule.data.message);

        case 'isMatch':
          if (rule.data) {
            return _validators.default.isMatch(rule.data.sectionId, rule.data.fieldId, rule.data.message);
          } else {
            return _validators.default.isMatch();
          }

        case 'isMatchingValue':
          return _validators.default.isMatch(rule.data.sectionId, rule.data.fieldId, rule.data.message, rule.data.options);

        case 'isNotMatchingValue':
          return _validators.default.isMatch(rule.data.sectionId, rule.data.fieldId, rule.data.message, rule.data.options);

        case 'isMoreThan':
          return _validators.default.isMoreThan(rule.data.message, rule.data.options, rule.data.fieldID);

        case 'isNotEqualTo':
          if (rule.data) {
            return _validators.default.isNotEqualTo(rule.data.message, rule.data.fieldID);
          } else {
            return _validators.default.isNotEqualTo();
          }

        case 'isNotMoreThan':
          return _validators.default.isNotMoreThan(rule.data.message, rule.data.options, rule.data.fieldID);

        case 'isNotLessThan':
          return _validators.default.isNotLessThan(rule.data.message, rule.data.options, rule.data.fieldID);

        case 'isNumeric':
          if (rule.data) {
            return _validators.default.isNumeric(rule.data.message);
          } else {
            return _validators.default.isNumeric();
          }

        case 'isPassword':
          if (rule.data) {
            return _validators.default.isPassword(rule.data.message);
          } else {
            return _validators.default.isPassword();
          }

        case 'isPhone':
          if (rule.data) {
            return _validators.default.isPhone(rule.data.message);
          } else {
            return _validators.default.isPhone();
          }

        case 'isRequired':
          return _validators.default.isRequired(rule.data.message);

        case 'isStructuredAddress':
          return _validators.default.isStructuredAddress(rule.data && rule.data.message);

        case 'isValidDate':
          if (rule.data) {
            return _validators.default.isValidDate(rule.data.message);
          } else {
            return _validators.default.isValidDate();
          }

        case 'isValidTime':
          if (rule.data) {
            return _validators.default.isValidTime(rule.data.message);
          } else {
            return _validators.default.isValidTime();
          }

        default:
          console.log('Unrecognized validator found in config');
      }
    }
  }]);

  return FormConfigParser;
}();

exports.default = FormConfigParser;
//# sourceMappingURL=ConfigParser.js.map